import React, {
	createContext,
	PropsWithChildren,
	ReactElement,
	useContext,
	useEffect,
	useRef,
	useState,
} from 'react';

import { switchHorizontal } from '@/assets/icons';
import { CopilotHeader } from '@/components/CopilotHeader';
import { PublicCopilotLayout } from '@/components/PublicCopilotLayout';
import { AsaphButton } from '@/components/shared/Button';
import { ItemsList } from '@/components/shared/ItemsList';
import { privacyPolicyLink, termsOfServiceLink } from '@/config/constants';
import { useErrorHandler } from '@/hooks/useErrorHandler';
import { useAuth } from '@/providers/AuthProvider';
import { useEnvironment } from '@/providers/EnvironmentProvider';
import { GraphQlTransportWsNextOperation } from '@/providers/TeamActionSubscription';
import { SvgIcon } from '@material-ui/core';
import axios, { AxiosError } from 'axios';
import { format } from 'date-fns';
import {
	OptionsObject,
	SnackbarKey,
	SnackbarMessage,
	useSnackbar,
} from 'notistack';

import {
	CopilotContext,
	CopilotState,
	sendMessageToPco,
} from '../../CopilotPage';
import styles from '../CopilotPage.module.scss';
import EmailForm from './EmailForm';
import VerifyForm from './VerifyForm';

type AuthErrorResponse = {
	code: string;
	message: string;
};

const CopilotLinkUser: React.FC = () => {
	const { authData, setToken, setState, token } = useContext(CopilotContext);
	const {
		api: { url },
		environment,
	} = useEnvironment();
	const { handleError } = useErrorHandler();

	const [email, setEmail] = useState<string | null>(null);

	return (
		<>
			{!email && <EmailForm onChange={setEmail} />}
			{!!email && <VerifyForm email={email} onChange={setEmail} />}
		</>
	);
};

export default CopilotLinkUser;
